<section class="body-section academies-profile-reviews">
    <p-toast key="toastMsg"></p-toast>
    <div class="container">
        <div class="row">
            <div class="col-md-12 reviews-page-div">
                <div class="header-container box w-100">
                    <div class="heading-headers">
                        <span class="mobile-icons" onclick="history.back()"> <i class="pi pi-arrow-left "></i> </span>
                        <h3>
                            user reviews
                        </h3>
                    </div>
                    <div class="users-list">
                        <!--main review list -->
                        <ul class="review-list-ul">
                            <li *ngFor="let review of reviewsList" class="reviw-user-main">
                                <div class="review-comment-show">
                                    <div class="media">
                                        <img class="align-self-center mr-3" src="{{review.userProfilePic}}"
                                            alt="customer-profile">
                                        <div class="media-body">
                                            <div class="customer-name">
                                                <h4>{{review.userName}}</h4>
                                            </div>
                                            <div class="rateing-star-customer">
                                                <p-rating [cancel]="false" [readonly]="true" [(ngModel)]="review.rating"
                                                    iconOnClass="pi pi-star-fill" iconOffClass="pi pi-star"></p-rating>
                                            </div>
                                            <span class="reviewed-date">
                                                <b>Date:</b>
                                                {{review.created_at|date:'dd-MM-YYYY'}}
                                            </span>
                                            <div class="customer-comment">
                                                <span class="comments"><b>Comment:</b></span>
                                                <p> {{review.comments}} </p>
                                            </div>
                                        </div>

                                    </div>
                                    <!--Customer-text-review-->
                                    <!-- <div class="delet-icons">
                                        <button (click)="onClickDelete(review)"><i class="pi pi-trash"></i></button>
                                    </div> -->
                                </div>
                            </li>
                            <div *ngIf="reviewsList?.length == 0" class="reivewNotFound">
                                <div class="col-md-12 reviewIcon">
                                    <div class="icon">
                                        <img src="../../../../assets/img/loader/reviewnot.png" alt="">
                                    </div>
                                </div>
                                <h6>
                                    Oops! It looks like there are no reviews for this academy at the moment.
                                </h6>
                            </div>
                        </ul>
                        <div class="more-review-div" *ngIf="reviewsList?.length > 0">
                            <button *ngIf="reviewsList?.length > 0" type="button" (click)="onClickLoadMore()" name="button"
                                class="review-more-button">
                                Load More Reviews
                            </button>
                        </div>
                      
                        <!--main review list close -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<p-confirmDialog [style]="{width: '500px'}" [breakpoints]="{ '768px': 'calc(100% - 30px)' }"></p-confirmDialog>
